// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Wrapper_wrapper__207Zo","body":"Wrapper_body__1K01l"};